<template>
  <div>
    <div class="system-container">
      <!-- 表单类型区域 -->
      <!-- <div class="form-type">
        <div class="area-title">题目类型区域</div>
        <div>
          <div
            v-for="(item, index) in formAreaList"
            :key="index"
            :class="getFormTypeClass(item.type, index)"
            @click="formTypeChange(index, item.type)"
          >
            <img :style="formAreaConfig.IconStyle" :src="item.icon" alt="图标" />
            <div class="form-area-label">{{ item.label }}</div>
          </div>
        </div>
      </div> -->
      <!-- 问卷编辑区域 -->
      <div class="questionnaire-edit">
        <div class="area-title">
          {{ Object.keys(editFormRecord).length ? '编辑' : '新增' }}题目区域
        </div>
        <div class="form-area">
          <component
            v-if="showQueTableStatus"
            :evaluationId="evaluationId"
            :is="currFormType"
            :insertNum="insertNum"
            :editFormRecord="editFormRecord"
            @cancelEdit="cancelEdit"
            @refreshData="refreshData"
          />
        </div>
      </div>
      <!-- 问卷列表区域 -->
      <div class="questionnaire-list">
        <div class="area-title">题目列表/预览区域</div>
        <a-tabs default-active-key="1">
          <a-tab-pane key="1">
            <span slot="tab">
              <a-icon type="apple" />
              列表预览
            </span>
            <QuestionTable
              v-if="showQueTableStatus"
              :evaluationId="evaluationId"
              :dataSource="dataSource"
              @editForm="editForm"
              @insertionForm="insertionForm"
              @refreshData="refreshData"
            />
          </a-tab-pane>
          <a-tab-pane key="2">
            <span slot="tab">
              <a-icon type="android" />
              量表预览
            </span>
            <QuesPreview class="scroll-area" :dataSource="dataSource" />
          </a-tab-pane>
        </a-tabs>
      </div>
      <div class="fixed-btn-area">
        <a-popconfirm ok-text="是" cancel-text="否" @confirm="$router.go(-1)">
          <template slot="title">
            <p>新增问卷模式下，取消操作会导致未保存的表单内容丢失</p>
            <p>确认要取消吗？</p>
          </template>
          <a-button>取消</a-button>
        </a-popconfirm>
        <a-button style="margin: 0px 12px" @click="prevClick">上一步</a-button>
        <a-button @click="nextClick">下一步</a-button>
      </div>
    </div>
  </div>
</template>
<script>
// 组件
import Judgment from './components/Judgment'
import MultipleChoice from './components/MultipleChoice'
import SingleChoice from './components/SingleChoice'
import ShortAnswer from './components/ShortAnswer'
import QuestionTable from './components/QuestionTable'
import QuesPreview from './components/QuesPreview'
import { getAction } from '@api/manage'

export default {
  name: 'CreateQuesTopic',
  components: {
    Judgment,
    MultipleChoice,
    SingleChoice,
    ShortAnswer,
    QuestionTable,
    QuesPreview,
  },
  props: {
    evaluationId: {
      type: String,
      default: '',
    },
    quesData: {
      type: Object,
      default: () => ({}),
    },
    formAreaConfig: {
      type: Object,
      default: () => ({
        IconStyle: {
          width: '40px',
          height: '40px',
        },
      }),
    },
  },
  data() {
    return {
      formAreaList: [
        // { label: '判断题', type: 'Judgment', icon: '' },
        { label: '单选题', type: 'SingleChoice', icon: '' },
        // { label: '多选题', type: 'MultipleChoice', icon: selectIcon },
        // { label: '简答题', type: 'ShortAnswer', icon: inputIcon },
      ],
      currFormTypeIndex: 0,
      currFormType: 'SingleChoice',
      showQueTableStatus: true,
      editFormRecord: {},
      insertNum: 0,
      currIndexlist: [], // 指标项
      dataSource: [], // 题目列表数据
    }
  },
  created() {
    this.getTopicInfo()
  },
  watch: {
    quesData: {
      handler() {
        this.getTopicInfo()
      },
      deep: true,
      // immediate: true,
    },
  },
  methods: {
    getFormTypeClass(type, index) {
      return {
        [`form-type-${type}`]: true,
        'form-area-list': true,
        'active-form-type': index == this.currFormTypeIndex,
      }
    },
    getTopicInfo() {
      if (!Object.keys(this.quesData).length) return
      getAction('/schoolEvaluationQuestion/getByEvaluationId', {
        evaluationId: this.evaluationId,
      }).then((res) => {
        if (res.success) {
          // console.log('题目信息：', res)
          this.dataSource = res.result.map((item, index) => ({
            ...item,
            index: index + 1,
          }))
        }
      })
    },
    formTypeChange(index, type) {
      this.currFormTypeIndex = index
      this.currFormType = type
      this.insertNum = 0
      this.editFormRecord = {}
    },
    refreshData(data) {
      this.getTopicInfo()
    },
    // 编辑题目
    editForm(record) {
      this.editFormRecord = record
    },
    // 取消编辑模式
    cancelEdit() {
      console.log('取消编辑')

      this.editFormRecord = {}
    },
    // 插入题目
    insertionForm(record, insertNum) {
      this.currFormType = record.type
      this.currFormTypeIndex = this.formAreaList.findIndex((item) => item.type === record.type)
      this.insertNum = insertNum
    },
    // 获取指标项列表
    getIndexList(list) {
      this.currIndexlist = list
    },
    prevClick() {
      this.$emit('prevClick')
    },
    nextClick() {
      this.$emit('nextClick')
    },
  },
}
</script>
<style lang="less" scoped>
.system-container {
  display: flex;
  width: 100%;
  height: 70vh;
  padding: 20px 0;
  border: 2px solid #eee;
  border-radius: 10px;
  overflow: hidden;
  background-color: #fff;
  > div {
    padding: 0 20px;
  }
  .form-type {
    width: 14%;
    height: 100%;
    border-right: 1px solid #eee;
    .form-area-list {
      display: flex;
      align-items: center;
      padding: 10px;
      margin: 15px 0;
      border: 1px solid #eee;
      border-radius: 4px;
      overflow: hidden;
      cursor: pointer;
      box-shadow: 0px 1px 6px 0px rgba(100, 100, 111, 0.22);
      .form-area-label {
        margin-left: 4px;
      }
    }
    // 动画效果
    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translateY(-5px) scale(0.9);
        background-color: hsl(210, 100%, 96%);
      }
      to {
        opacity: 1;
        transform: translateY(0) scale(1);
        background-color: #a4d1fb;
      }
    }
    .active-form-type {
      background-color: #a4d1fb;
      animation: fadeIn 0.3s ease-in-out;
    }
  }
  .questionnaire-list {
    flex: 1;
    height: 100%;
    border-right: 1px solid #eee;
    .scroll-area {
      max-height: 50vh;
      overflow-y: auto;
      padding: 0px 20px;
    }
  }
  .questionnaire-edit {
    width: 42%;
    border-right: 1px solid #eee;
    .form-area {
      height: 100%;
      padding: 0 20px 20px 20px;
      overflow-y: auto;
    }
  }
  .area-title {
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: bold;
  }
  .fixed-btn-area {
    position: fixed;
    bottom: 70px;
    right: 70px;
    background: #fff;
  }
}
</style>
